import type { FinanceState } from "web_myplann/Finances/State/FinanceAtom";
import type { FinanceChartDataPoint } from "web_myplann/Finances/Types/FinanceChartDataPoint";

export const mapIncomeToChartData = (
	income: FinanceState["income"][number],
): FinanceChartDataPoint => ({
	value: income.amount,
	label: income.name,
});
